import { useEffect, useRef } from "react";
import Plotly from "plotly.js-dist-min";
import { RACE_COLORS, FONT_FAMILY, IS_TOUCH } from "../constants.js";

export default function RaceDonut({ data }) {
  const ref = useRef();

  useEffect(() => {
    if (!data || !data.length) return;

    // Sort ascending by pct so small slices cluster at bottom
    const sorted = [...data].sort((a, b) => a.pct - b.pct);
    const smallTotal = sorted.filter(d => d.pct < 10).reduce((s, d) => s + d.pct, 0);
    const rotation = (270 - (smallTotal / 100 * 360) / 2 + 360) % 360;

    const trace = {
      type: "pie",
      values: sorted.map(d => d.count),
      labels: sorted.map(d => d.race),
      hole: 0.4,
      rotation,
      marker: { colors: sorted.map(d => RACE_COLORS[d.race] || "#aaaaaa") },
      customdata: sorted.map(d => [d.race]),
      texttemplate: "%{customdata[0]}<br>%{percent:.1%}",
      textposition: "auto",
      automargin: true,
      insidetextorientation: "horizontal",
      textfont: { size: 12, color: "white", family: FONT_FAMILY },
      outsidetextfont: { size: 12, color: "#333333", family: FONT_FAMILY },
      hovertemplate: "<b>%{label}</b><br>%{value} stops<br>%{percent:.1%}<extra></extra>",
    };

    Plotly.react(ref.current, [trace], {
      title: {
        text: "<b>Race</b>",
        font: { size: 18, color: "#333333", family: FONT_FAMILY },
        x: 0, xanchor: "left",
      },
      showlegend: false,
      height: 420,
      margin: { l: 80, r: 80, t: 60, b: 80 },
      font: { family: FONT_FAMILY },
      paper_bgcolor: "white",
    }, { responsive: true, displayModeBar: false, staticPlot: IS_TOUCH });
  }, [data]);

  if (!data || !data.length) return null;
  return (
    <div>
      <p style={{ fontFamily: FONT_FAMILY, fontSize: 14, fontStyle: "italic", color: "#555", margin: "4px 0 0" }}>What is the racial breakdown of people this officer stops?</p>
      <div className="chart-scroll-x">
        <div ref={ref} style={{ minWidth: 320 }} />
      </div>
    </div>
  );
}
